import {ValueAndLabelModel} from '../../../../../modules/common/model/valueAndLabel.model';
import {ThemePalette} from '@angular/material/core';

export class ConfirmationButtonOptionButton extends ValueAndLabelModel {
    color: ThemePalette;
}

export class ConfirmationButtonOptionModel {


    static readonly DEFAULT_BUTTONS: ConfirmationButtonOptionButton[] = [{
        value: 'DEFAULT',
        label: 'Valider',
        color: 'warn'
    }];

    static readonly DEFAULT_CONFIRMATION_TEXT = 'Êtes-vous certain?';

    buttons?: ConfirmationButtonOptionButton[];
    confirmationText?: string;
}

export const CONFIRMATION_BUTTON_DEFAULT_OPTIONS: ConfirmationButtonOptionModel = {
    buttons: ConfirmationButtonOptionModel.DEFAULT_BUTTONS,
    confirmationText: ConfirmationButtonOptionModel.DEFAULT_CONFIRMATION_TEXT
};
